'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
interface LuxuryHeroProps {
  videoUrl?: string;
  fallbackImageUrl?: string;
  title?: string;
  subtitle?: string;
}
export default function LuxuryHero(t0) {
  const $ = _c(37);
  const {
    videoUrl,
    fallbackImageUrl: t1,
    title: t2,
    subtitle: t3
  } = t0;
  const fallbackImageUrl = t1 === undefined ? "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=2000&q=80" : t1;
  const title = t2 === undefined ? "Extraordinary Residences" : t2;
  const subtitle = t3 === undefined ? "Discover an unparalleled collection of luxury properties, where exceptional living meets timeless elegance" : t3;
  const [isLoaded, setIsLoaded] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const router = useRouter();
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const timer = setTimeout(() => setIsLoaded(true), 100);
      return () => clearTimeout(timer);
    };
    t5 = [];
    $[0] = t4;
    $[1] = t5;
  } else {
    t4 = $[0];
    t5 = $[1];
  }
  useEffect(t4, t5);
  let t6;
  if ($[2] !== router || $[3] !== searchQuery) {
    t6 = e => {
      e.preventDefault();
      if (searchQuery.trim()) {
        router.push(`/real-estate-for-sale?keyword=${encodeURIComponent(searchQuery.trim())}`);
      } else {
        router.push("/real-estate-for-sale");
      }
    };
    $[2] = router;
    $[3] = searchQuery;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const handleSearch = t6;
  let t7;
  if ($[5] !== fallbackImageUrl || $[6] !== videoUrl) {
    t7 = videoUrl ? <video autoPlay={true} loop={true} muted={true} playsInline={true} className="w-full h-full object-cover" style={{
      filter: "brightness(0.7) contrast(1.05)"
    }} poster={fallbackImageUrl}><source src={videoUrl} type="video/mp4" /></video> : <div className="w-full h-full bg-cover bg-center transform scale-105 transition-transform duration-[20000ms] ease-linear" style={{
      backgroundImage: `url(${fallbackImageUrl})`,
      filter: "brightness(0.7) contrast(1.05)"
    }} />;
    $[5] = fallbackImageUrl;
    $[6] = videoUrl;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="absolute inset-0 bg-gradient-to-b from-[#1a1a1a]/50 via-transparent to-[#1a1a1a]/80" />;
    t9 = <div className="absolute inset-0 bg-gradient-to-r from-[#1a1a1a]/30 via-transparent to-[#1a1a1a]/30" />;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t7) {
    t10 = <div className="absolute inset-0">{t7}{t8}{t9}</div>;
    $[10] = t7;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = `font-luxury text-white uppercase mb-8 max-w-5xl transition-all duration-1000 delay-400 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`;
  let t12;
  if ($[12] !== t11 || $[13] !== title) {
    t12 = <h1 className={t11}>{title}</h1>;
    $[12] = t11;
    $[13] = title;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const t13 = `font-luxury-body text-white/60 text-sm md:text-base font-light tracking-[0.03em] max-w-lg mb-12 leading-[1.8] transition-all duration-1000 delay-500 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`;
  let t14;
  if ($[15] !== subtitle || $[16] !== t13) {
    t14 = <p className={t13}>{subtitle}</p>;
    $[15] = subtitle;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  const t15 = `w-full max-w-2xl transition-all duration-1000 delay-600 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`;
  let t16;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = e_0 => setSearchQuery(e_0.target.value);
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== searchQuery) {
    t17 = <input type="text" value={searchQuery} onChange={t16} placeholder="Address, city, neighborhood..." className="font-luxury-body flex-1 px-6 py-4 bg-white/5 backdrop-blur-sm border border-white/20 border-r-0 text-white text-sm placeholder-white/30 tracking-[0.05em] focus:outline-none focus:border-white/40 focus:bg-white/10 transition-all duration-500" />;
    $[19] = searchQuery;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  let t19;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="hidden sm:inline border-b border-white/30 pb-1 group-hover:border-white transition-colors duration-500">Explore Properties</span>;
    t19 = <span className="sm:hidden border-b border-white/30 pb-1 group-hover:border-white transition-colors duration-500">Search</span>;
    $[21] = t18;
    $[22] = t19;
  } else {
    t18 = $[21];
    t19 = $[22];
  }
  let t20;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <button type="submit" className="font-luxury-body group flex items-center gap-4 px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-[13px] uppercase tracking-[0.25em] font-normal hover:bg-white/20 hover:border-white/40 transition-all duration-500">{t18}{t19}<svg className="w-4 h-4 transform group-hover:translate-x-2 transition-transform duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg></button>;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] !== t17) {
    t21 = <div className="flex items-stretch">{t17}{t20}</div>;
    $[24] = t17;
    $[25] = t21;
  } else {
    t21 = $[25];
  }
  let t22;
  if ($[26] !== handleSearch || $[27] !== t15 || $[28] !== t21) {
    t22 = <form onSubmit={handleSearch} className={t15}>{t21}</form>;
    $[26] = handleSearch;
    $[27] = t15;
    $[28] = t21;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  let t23;
  if ($[30] !== t12 || $[31] !== t14 || $[32] !== t22) {
    t23 = <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-6">{t12}{t14}{t22}</div>;
    $[30] = t12;
    $[31] = t14;
    $[32] = t22;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== t10 || $[35] !== t23) {
    t24 = <section className="relative w-full h-screen min-h-[800px] overflow-hidden bg-[#1a1a1a]">{t10}{t23}</section>;
    $[34] = t10;
    $[35] = t23;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  return t24;
}